<template lang="pug">
b-navbar#the-header(
  sticky
  toggleable="md"
  variant="light"
  type="light"
)
  b-container
    b-navbar-toggle(
      v-if="showUserInfo"
      target="nav_collapse"
    )
    b-navbar-brand(href='#')
      img#the-header__logo-mfar(
        v-if="instance === 'mfar'"
        src="/repository/img/mfar.png"
      )
      img#the-header__logo-mfar(
        v-if="instance === 'mfarevents'"
        src="/repository/img/mfarevents.png"
      )
      img#the-header__logo-gecp(
        v-if="instance === 'gecp'"
        src="/repository/img/Logo_GECP_noText.png"
      )
    b-collapse#nav_collapse(
      v-if="showUserInfo"
      is-nav
    )
      b-navbar-nav.ml-auto.text-dark
        b-nav-form
          project-searcher#the-header__project-searcher.mr-3
        b-nav-item-dropdown(
          right
        )
          template(slot="button-content")
            i.fa.fa-user-circle.mr-2
            a-badge#the-header__user-name(
            ) {{name}}
          b-dropdown-item(
            @click="showMyDataModal()"
          ) {{ $t('components.the_header.tpl.my_data') }}
          b-dropdown-item(
            @click="showTaskPanelModal()"
          ) {{ $t('components.the_header.tpl.task_panel') }}
          b-dropdown-item(
            @click="showChangePasswordModal()"
          ) {{ $t('components.the_header.tpl.change_password') }}
          b-dropdown-divider
          b-dropdown-item(
            @click="openCrdExport()"
          )
            | {{ $t('components.the_header.tpl.crd_export') }}
            i.fa.fa-external-link.ml-2
        b-nav-item#do-logout(
          @click="doLogoutAndGoLogin()"
        )
          i.fa.fa-sign-out.mr-2
          span.d-inline.d-md-none.d-lg-none.d-xl-inline {{ $t('components.the_header.tpl.logout') }}
    my-data-modal(
      v-if="myDataModalIsVisible"
      v-on:hide="hideMyDataModal()"
    )
    change-password-modal(
      v-if="changePasswordModalIsVisible"
      v-on:hide="hideChangePasswordModal()"
    )
    task-panel-modal(
      v-if="taskPanelModalIsVisible"
      v-on:hide="hideTaskPanelModal()"
    )

</template>

<script>
import {
  mapState,
  mapActions,
} from 'vuex';

import { isNil } from 'lodash';
import { param } from 'jquery';

import MyDataModal from '@/components/MyDataModal';
import ChangePasswordModal from '@/components/ChangePasswordModal';
import ProjectSearcher from '@/components/ProjectSearcher';
import TaskPanelModal from '@/components/TaskPanelModal';

export default {
  components: {
    MyDataModal,
    ChangePasswordModal,
    ProjectSearcher,
    TaskPanelModal,
  },
  data() {
    return {
      myDataModalIsVisible: false,
      changePasswordModalIsVisible: false,
      taskPanelModalIsVisible: false,
    };
  },
  computed: {
    ...mapState({
      locale: state => state.locale,
    }),
    ...mapState('login', {
      name: state => state.user.name,
      userId: state => state.user.id,
      username: state => state.user.username,
      instance: state => state.instance,
      token: state => state.token,
    }),
    showUserInfo() {
      return !isNil(this.username) && this.$route.name === 'projects';
    },
  },
  methods: {
    ...mapActions('login', [
      'doLogout',
    ]),
    doLogoutAndGoLogin() {
      this.hideMyDataModal();
      this.hideChangePasswordModal();
      this.doLogout();

      if (this.locale !== 'es') {
        this.$router.push({
          path: `/${this.instance}/${this.locale}`,
        });
        return;
      }

      this.$router.push({
        path: `/${this.instance}`,
      });
    },
    openCrdExport() {
      const params = param({
        userId: this.userId,
        instance: this.instance,
        token_type: this.token && this.token.token_type,
        access_token: this.token && this.token.access_token,
      });

      const CRD_EXPORT_URL = `${process.env.VUE_APP_CRD_EXPORT_URL}`;
      const crdExportURL = `${CRD_EXPORT_URL}/login-bridge?${params}`;

      window.open(crdExportURL, '_blank');
    },
    showMyDataModal() {
      this.myDataModalIsVisible = true;
    },
    hideMyDataModal() {
      this.myDataModalIsVisible = false;
    },
    showChangePasswordModal() {
      this.changePasswordModalIsVisible = true;
    },
    hideChangePasswordModal() {
      this.changePasswordModalIsVisible = false;
    },
    showTaskPanelModal() {
      this.taskPanelModalIsVisible = true;
    },
    hideTaskPanelModal() {
      this.taskPanelModalIsVisible = false;
    },
  },
};
</script>


<style scoped>
#the-header {
  z-index: 999;
  border-bottom: 1px solid #e7e7e7;
  min-height: 66px;
}
#the-header__logo-mfar {
  width: 150px;
}
#the-header__logo-gecp {
  width: 65px;
}
#the-header__user-name {
  font-family: "Montserrat", sans-serif;
  font-size: inherit;
}

#the-header__project-searcher {
  width: 310px;
}
</style>
